// Splits a title into [lead, lastWord, trailingPunctuation] so the last word can be highlighted,
// keeping trailing punctuation ("Why Choose Us ?") outside the highlight.
export const splitLastWord = (title) => {
    const text = (title || '').trim();
    const match = text.match(/^(.*?)(\S+?)\s*([?!.:]*)$/);
    return match ? [match[1], match[2], match[3]] : ['', text, ''];
}

// Section heading with a marker-style highlight behind the last word, e.g. "Our [Services]".
function SectionHeading({ title, as: Tag = 'h2', className = '' }) {
    if(!(title || '').trim()) {
        return null;
    }
    const [lead, word, punctuation] = splitLastWord(title);
    return (
        <div className={`section-title section-heading ${className}`.trim()}>
            <Tag className="section-heading__title">
                {lead}<span className="section-heading__mark">{word}</span>{punctuation}
            </Tag>
        </div>
    );
}

export default SectionHeading;
